import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import datetimeHelper from "../../helper/datetime-helper";
import { UPDATE_LIST_INTERACTIVELOG } from "../telesale/call";
import * as apiCaller from "./../../api/apiCaller";

export const GET_LIST_TYPE_TICKET = "GET_LIST_TYPE_TICKET";
export const GET_LIST_TYPE_TICKET_ERROR = "GET_LIST_TYPE_TICKET_ERROR";
export const GET_LIST_TYPE_TICKET_SUCCESS = "GET_LIST_TYPE_TICKET_SUCCESS";

export const ADD_NEW_TICKET = "ADD_NEW_TICKET";
export const ADD_NEW_TICKET_ERROR = "ADD_NEW_TICKET_ERROR";
export const ADD_NEW_TICKET_SUCCESS = "ADD_NEW_TICKET_SUCCESS";

export const UPDATE_TICKET = "UPDATE_TICKET";
export const UPDATE_TICKET_SUCCESS = "UPDATE_TICKET_SUCCESS";
export const UPDATE_TICKET_ERROR = "UPDATE_TICKET_ERROR";

export const GET_CONTACT = "GET_CONTACT";
export const GET_CONTACT_SUCCESS = "GET_CONTACT_SUCCESS";
export const GET_CONTACT_ERROR = "GET_CONTACT_ERROR";

export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const GET_EMPLOYEE_SUCCESS = "GET_EMPLOYEE_SUCCESS";
export const GET_EMPLOYEE_ERROR = "GET_EMPLOYEE_ERROR";

export const GET_POS = "GET_POS";
export const GET_POS_SUCCESS = "GET_POS_SUCCESS";
export const GET_POS_ERROR = "GET_POS_ERROR";

export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_ERROR = "GET_PRODUCT_ERROR";

export const GET_SALE_ORDER = "GET_SALE_ORDER";
export const GET_SALE_ORDER_SUCCESS = "GET_SALE_ORDER_SUCCESS";
export const GET_SALE_ORDER_ERROR = "GET_SALE_ORDER_ERROR";

export const GET_PACKAGE = "GET_PACKAGE";
export const GET_PACKAGE_SUCCESS = "GET_PACKAGE_SUCCESS";
export const GET_PACKAGE_ERROR = "GET_PACKAGE_ERROR";

export const GET_LIST_TICKET = "GET_LIST_TICKET";
export const GET_LIST_TICKET_SUCCESS = "GET_LIST_TICKET_SUCCESS";
export const GET_LIST_TICKET_ERROR = "GET_LIST_TICKET_ERROR";
export const GET_LIST_TICKET_NO_REPORT_SUCCESS =
  "GET_LIST_TICKET_NO_REPORT_SUCCESS";

export const GET_REPORT_TICKET = "GET_REPORT_TICKET";

export const COUNT_LIST_TICKET = "COUNT_LIST_TICKET";
export const COUNT_LIST_TICKET_SUCCESS = "COUNT_LIST_TICKET_SUCCESS";
export const COUNT_LIST_TICKET_ERROR = "COUNT_LIST_TICKET_ERROR";

export const COUNT_REPORT_TICKET = "COUNT_REPORT_TICKET";

export const COUNT_LIST_TICKET_BY_PHONE = "COUNT_LIST_TICKET_BY_PHONE";
export const COUNT_LIST_TICKET_BY_PHONE_SUCCESS =
  "COUNT_LIST_TICKET_BY_PHONE_SUCCESS";
export const COUNT_LIST_TICKET_BY_PHONE_ERROR =
  "COUNT_LIST_TICKET_BY_PHONE_ERROR";

export const ADD_TICKET_SUCCESS_NOTI = "ADD_TICKET_SUCCESS_NOTI";
export const UPDATE_TICKET_SUCCESS_NOTI = "UPDATE_TICKET_SUCCESS_NOTI";
export const ADD_TICKET_ERROR_NOTI = "ADD_TICKET_ERROR_NOTI";
export const UPDATE_TICKET_ERROR_NOTI = "COUNT_LIST_TICKET_BY_PHONE_ERROR";

export const UPDATE_LIST_TICKET = "UPDATE_LIST_TICKET";

/**
 * Reducer
 */

const initialState = {
  ticketType: [],
  error: false,
  ticket: [],
  contact: [],
  employee: [],
  pos: [],
  product: [],
  saleOrder: [],
  package: [],
  const: 0,
  countByPhone: 0,
  loadingTicket: false,
  loadingEp: false,
  tickets: [],
  loading: false,
};

export const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_TYPE_TICKET:
      return {
        ...state,
      };
    case GET_LIST_TYPE_TICKET_SUCCESS:
      return {
        ...state,
        ticketType: action.payload,
      };
    case GET_LIST_TYPE_TICKET_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //get list tickege
    case GET_LIST_TICKET:
    case GET_REPORT_TICKET:
      return {
        ...state,
        loadingTicket: true,
      };
    case GET_LIST_TICKET_SUCCESS:
      return {
        ...state,
        ticket: action.payload,
        loadingTicket: false,
      };
    case GET_LIST_TICKET_NO_REPORT_SUCCESS:
      return {
        ...state,
        tickets: action.payload,
        loadingTicket: false,
      };
    case GET_LIST_TICKET_ERROR:
      return {
        ...state,
        error: action.error,
        loadingTicket: false,
      };
    //get list
    case COUNT_LIST_TICKET:
      return {
        ...state,
      };
    case COUNT_LIST_TICKET_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_TICKET_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_CONTACT:
      return {
        ...state,
      };
    case GET_CONTACT_SUCCESS:
      return {
        ...state,
        contact: action.payload,
      };
    case GET_CONTACT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_EMPLOYEE:
      return {
        ...state,
        loadingEp: true,
      };
    case GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employee: action.payload,
        loadingEp: false,
      };
    case GET_EMPLOYEE_ERROR:
      return {
        ...state,
        error: action.error,
        loadingEp: true,
      };

    case GET_POS:
      return {
        ...state,
      };
    case GET_POS_SUCCESS:
      return {
        ...state,
        pos: action.payload,
      };
    case GET_POS_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_PRODUCT:
      return {
        ...state,
      };
    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        product: action.payload,
      };
    case GET_PRODUCT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_SALE_ORDER:
      return {
        ...state,
      };
    case GET_SALE_ORDER_SUCCESS:
      return {
        ...state,
        saleOrder: action.payload,
      };
    case GET_SALE_ORDER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //add new
    case ADD_NEW_TICKET:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        ticket: action.payload,
      };
    case ADD_NEW_TICKET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // update ticket
    case UPDATE_TICKET:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        ticket: action.payload,
      };
    case UPDATE_TICKET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    //package
    case GET_PACKAGE:
      return {
        ...state,
        loading: true,
      };
    case GET_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        package: action.payload,
      };
    case GET_PACKAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    //count
    case COUNT_LIST_TICKET_BY_PHONE:
      return {
        ...state,
      };
    case COUNT_LIST_TICKET_BY_PHONE_SUCCESS:
      return {
        ...state,
        countByPhone: action.payload,
      };
    case COUNT_LIST_TICKET_BY_PHONE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case UPDATE_LIST_TICKET:
      const { data } = action.data;
      const tickets = state.tickets.map((val) => {
        if (val.id === data.id) {
          return {
            ...val,
            ...data,
          };
        }
        return val;
      });
      return {
        ...state,
        tickets,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const addNewTicketSuccessNoti = () => ({
  type: ADD_TICKET_SUCCESS_NOTI,
});

export const updateTicketSuccessNoti = () => ({
  type: UPDATE_TICKET_SUCCESS_NOTI,
});

export const addTicketErrorNoti = () => ({
  type: ADD_TICKET_ERROR_NOTI,
});

export const updateTicketErrorNoti = () => ({
  type: UPDATE_TICKET_ERROR_NOTI,
});

export const getTicketType = () => ({
  type: GET_LIST_TYPE_TICKET,
});

export const getContactSF = () => ({
  type: GET_CONTACT,
});

export const getEmployeeSF = (name, limit) => ({
  type: GET_EMPLOYEE,
  data: {
    name,
    limit,
  },
});

export const getPosSF = () => ({
  type: GET_POS,
});

export const getProductSF = () => ({
  type: GET_PRODUCT,
});

export const getSaleOrderSF = () => ({
  type: GET_SALE_ORDER,
});

export const getPackageSF = () => ({
  type: GET_PACKAGE,
});

export const addNewTicket = (
  type,
  attributes,
  phone,
  source,
  interactivelogId,
  formResult,
  refId
) => ({
  type: ADD_NEW_TICKET,
  data: {
    type,
    attributes,
    phone,
    source,
    interactivelogId,
    formResult,
    refId,
  },
});

export const updateTicket = (
  id,
  type,
  attributes,
  phone,
  source,
  interactivelogId,
  formResult,
  refId
) => ({
  type: UPDATE_TICKET,
  data: {
    id,
    type,
    attributes,
    phone,
    source,
    interactivelogId,
    formResult,
    refId,
  },
});

export const getListTicket = (
  order,
  limit,
  skip,
  where,
  CaseNumber,
  query
) => ({
  type: GET_LIST_TICKET,
  data: {
    order,
    limit,
    skip,
    where,
    CaseNumber,
    query,
  },
});

export const getReportTicket = (
  order,
  limit,
  skip,
  where,
  CaseNumber,
  query
) => ({
  type: GET_REPORT_TICKET,
  data: {
    order,
    limit,
    skip,
    where,
    CaseNumber,
    query,
  },
});

export const countListTicket = (where, query) => ({
  type: COUNT_LIST_TICKET,
  data: {
    where,
    query,
  },
});

export const countReportTicket = (where) => ({
  type: COUNT_REPORT_TICKET,
  data: {
    where,
  },
});

export const countListTicketByPhone = (where) => ({
  type: COUNT_LIST_TICKET_BY_PHONE,
  data: {
    where,
  },
});

export const updateListTicket = (data) => ({
  type: UPDATE_LIST_TICKET,
  data: {
    data,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      addNewTicketSuccessNoti,
      updateTicketSuccessNoti,
      addTicketErrorNoti,
      updateTicketErrorNoti,
      updateTicket,
      getTicketType,
      addNewTicket,
      getContactSF,
      getEmployeeSF,
      getPosSF,
      getProductSF,
      getSaleOrderSF,
      getPackageSF,
      getListTicket,
      getReportTicket,
      countListTicket,
      countReportTicket,
      countListTicketByPhone,
      updateListTicket,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getTicketTypeApi = () => {
  return apiCaller.getLogs("/mini-crm/ticket-type", {
    where: { isActive: true },
  });
};
const getContactSFApi = () => {
  return apiCaller.get("/mini-crm//vnpost-crm-gateway/get-contact");
};
const getEmployeeSFApi = (name, limit) => {
  return apiCaller.getData(`/mini-crm/vnpost-crm-gateway/get-employee`, {
    name,
    limit,
  });
};
const getPosSFApi = () => {
  return apiCaller.get("/mini-crm/vnpost-crm-gateway/get-pos");
};
const getProductSFApi = () => {
  return apiCaller.get("/mini-crm/vnpost-crm-gateway/get-product");
};
const getSaleOrderSFApi = () => {
  return apiCaller.get("/mini-crm/vnpost-crm-gateway/get-sale-order");
};

const getPackageSFApi = () => {
  return apiCaller.get("/mini-crm/vnpost-crm-gateway/get-package");
};

const addNewTicketApi = (
  type,
  attributes,
  phone,
  source,
  interactivelogId,
  refId
) => {
  return apiCaller.post("/mini-crm/ticket", {
    type,
    ...attributes,
    phone,
    source,
    interactivelogId,
    refId,
  });
};

const updateTicketApi = (
  id,
  type,
  attributes,
  phone,
  source,
  interactivelogId,
  refId
) => {
  return apiCaller.put(`/mini-crm/ticket/${id}`, {
    type,
    ...attributes,
    phone,
    source,
    interactivelogId,
    refId,
  });
};

const getListTicketApi = (
  order,
  limit,
  skip,
  where,
  CaseNumber,
  query = {}
) => {
  let queryArray = [];
  Object.keys(query).map((key) => {
    queryArray.push(`${key}=${query[key]}`);
  });
  if (CaseNumber) {
    queryArray.push(`CaseNumber=${CaseNumber}`);
  }

  return apiCaller.getLogs(`/mini-crm/ticket?${queryArray.join("&")}`, {
    order,
    limit,
    skip,
    ...where,
  });
};

const getReportTicketApi = (order, limit, skip, where) => {
  return apiCaller.getData(`/mini-crm-v2/api/v1/ticket`, {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListTicketApi = (where, query = {}) => {
  let queryArray = [];
  Object.keys(query).map((key) => {
    queryArray.push(`${key}=${query[key]}`);
  });
  return apiCaller.getData(`/mini-crm/ticket/count?${queryArray.join("&")}`, {
    ...where,
  });
};
const countReportTicketApi = (where) => {
  return apiCaller.getData(`/mini-crm-v2/api/v1/ticket/count`, {
    ...where,
  });
};

const countListTicketByPhoneApi = (where) => {
  return apiCaller.getData("/mini-crm/ticket/count?query=log", { ...where });
};

/**
 * sagas
 */
export const getTicketTypeFlow = function* () {
  while (true) {
    yield take(GET_LIST_TYPE_TICKET);
    try {
      const res = yield call(getTicketTypeApi);
      yield put({ type: GET_LIST_TYPE_TICKET_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_TYPE_TICKET_ERROR, error });
    }
  }
};

export const getContactSFFlow = function* () {
  while (true) {
    yield take(GET_CONTACT);
    try {
      const res = yield call(getContactSFApi);
      yield put({ type: GET_CONTACT_SUCCESS, payload: res.data.body.results });
    } catch (error) {
      yield put({ type: GET_CONTACT_ERROR, error });
    }
  }
};
export const getEmployeeSFFlow = function* () {
  while (true) {
    const action = yield take(GET_EMPLOYEE);
    try {
      const res = yield call(
        getEmployeeSFApi,
        action.data.name,
        action.data.limit
      );
      yield put({ type: GET_EMPLOYEE_SUCCESS, payload: res.data.body.results });
    } catch (error) {
      yield put({ type: GET_EMPLOYEE_ERROR, error });
    }
  }
};
export const getPosSFFlow = function* () {
  while (true) {
    yield take(GET_POS);
    try {
      const res = yield call(getPosSFApi);
      yield put({ type: GET_POS_SUCCESS, payload: res.data.body.results });
    } catch (error) {
      yield put({ type: GET_POS_ERROR, error });
    }
  }
};
export const getProductSFFlow = function* () {
  while (true) {
    yield take(GET_PRODUCT);
    try {
      const res = yield call(getProductSFApi);
      yield put({ type: GET_PRODUCT_SUCCESS, payload: res.data.body.results });
    } catch (error) {
      yield put({ type: GET_PRODUCT_ERROR, error });
    }
  }
};

export const getSaleOrderSFFlow = function* () {
  while (true) {
    yield take(GET_SALE_ORDER);
    try {
      const res = yield call(getSaleOrderSFApi);
      yield put({
        type: GET_SALE_ORDER_SUCCESS,
        payload: res.data.body.results,
      });
    } catch (error) {
      yield put({ type: GET_SALE_ORDER_ERROR, error });
    }
  }
};

export const getPackageSFFlow = function* () {
  while (true) {
    yield take(GET_PACKAGE);
    try {
      const res = yield call(getPackageSFApi);
      yield put({ type: GET_PACKAGE_SUCCESS, payload: res.data.body.results });
    } catch (error) {
      yield put({ type: GET_PACKAGE_ERROR, error });
    }
  }
};

export const addNewTicketFlow = function* () {
  while (true) {
    const {
      data: {
        type,
        attributes,
        phone,
        source,
        interactivelogId,
        formResult,
        refId,
      },
    } = yield take(ADD_NEW_TICKET);
    try {
      const res = yield call(
        addNewTicketApi,
        type,
        attributes,
        phone,
        source,
        interactivelogId,
        refId
      );
      yield put({ type: ADD_NEW_TICKET_SUCCESS, payload: { ...res.data } });

      res.data.createdAt = datetimeHelper.toFormat(
        res.data.createdAt,
        "YYYY-MM-DD HH:mm:ss"
      );
      res.data.recallTime = datetimeHelper.toFormat(
        res.data.recallTime,
        "YYYY-MM-DD HH:mm:ss"
      );

      if (type === "outbound") {
        yield put({
          type: UPDATE_LIST_INTERACTIVELOG,
          payload: { ...res.data },
          formResult,
        }); // dispatch action in redux call
      }
    } catch (error) {
      yield put({ type: ADD_NEW_TICKET_ERROR, error });
    }
  }
};

export const updateTicketFlow = function* () {
  while (true) {
    const {
      data: {
        id,
        type,
        attributes,
        phone,
        source,
        interactivelogId,
        formResult,
        refId,
      },
    } = yield take(UPDATE_TICKET);
    try {
      const res = yield call(
        updateTicketApi,
        id,
        type,
        attributes,
        phone,
        source,
        interactivelogId,
        refId
      );
      yield put({ type: UPDATE_TICKET_SUCCESS, payload: { ...res.data } });

      res.data.createdAt = datetimeHelper.toFormat(
        res.data.createdAt,
        "YYYY-MM-DD HH:mm:ss"
      );
      res.data.recallTime = datetimeHelper.toFormat(
        res.data.recallTime,
        "YYYY-MM-DD HH:mm:ss"
      );

      if (type === "outbound") {
        yield put({
          type: UPDATE_LIST_INTERACTIVELOG,
          payload: { ...res.data },
          formResult,
        }); // dispatch action in redux call
      }
    } catch (error) {
      yield put({ type: UPDATE_TICKET_ERROR, error });
    }
  }
};

export const getListTicketFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_TICKET);
    try {
      let typeTicket = yield call(getTicketTypeApi);
      const res = yield call(
        getListTicketApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.CaseNumber,
        action.data.query
      );
      let _listTicket = [["Nội dung", "Số lượng"]];
      for (const key in typeTicket.data) {
        if (typeTicket.data.hasOwnProperty(key)) {
          const _typeTicket = typeTicket.data[key];
          if (
            _typeTicket.refId !== "luong-huu" &&
            _typeTicket.refId !== "co-cong"
          ) {
            let _checkTicket = res.data.filter(
              (item) => item.type == _typeTicket.id
            );
            if (_checkTicket) {
              _listTicket.push([_typeTicket.name, _checkTicket.length]);
            }
          }
        }
      }
      // res.data.push({ "dashboard": _listTicket })
      yield put({ type: GET_LIST_TICKET_SUCCESS, payload: _listTicket });
      yield put({ type: GET_LIST_TICKET_NO_REPORT_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_TICKET_ERROR, error });
    }
  }
};

export const getReportTicketFlow = function* () {
  while (true) {
    const action = yield take(GET_REPORT_TICKET);
    try {
      let typeTicket = yield call(getTicketTypeApi);
      const res = yield call(
        getReportTicketApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      let _listTicket = [["Nội dung", "Số lượng"]];
      for (const key in typeTicket.data) {
        if (typeTicket.data.hasOwnProperty(key)) {
          const _typeTicket = typeTicket.data[key];
          if (
            _typeTicket.refId !== "luong-huu" &&
            _typeTicket.refId !== "co-cong"
          ) {
            let _checkTicket = res.data.data.filter(
              (item) => item.type == _typeTicket.id
            );
            if (_checkTicket) {
              _listTicket.push([_typeTicket.name, _checkTicket.length]);
            }
          }
        }
      }
      // res.data.push({ "dashboard": _listTicket })
      yield put({ type: GET_LIST_TICKET_SUCCESS, payload: _listTicket });
      yield put({
        type: GET_LIST_TICKET_NO_REPORT_SUCCESS,
        payload: res.data.data,
      });
    } catch (error) {
      yield put({ type: GET_LIST_TICKET_ERROR, error });
    }
  }
};

export const countTicketFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_TICKET);
    try {
      const res = yield call(
        countListTicketApi,
        action.data.where,
        action.data.query
      );
      yield put({ type: COUNT_LIST_TICKET_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_TICKET_ERROR, error });
    }
  }
};
export const countReportTicketFlow = function* () {
  while (true) {
    const action = yield take(COUNT_REPORT_TICKET);
    try {
      const res = yield call(countReportTicketApi, action.data.where);
      yield put({ type: COUNT_LIST_TICKET_SUCCESS, payload: res.data.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_TICKET_ERROR, error });
    }
  }
};

export const countTicketByPhoneFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_TICKET_BY_PHONE);
    try {
      const res = yield call(countListTicketByPhoneApi, action.data.where);
      yield put({
        type: COUNT_LIST_TICKET_BY_PHONE_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_TICKET_BY_PHONE_ERROR, error });
    }
  }
};
